import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface IEnrollmentTrade {
  statusCode: number;
  message: string;
  code: string;
  timestamp: string;
  success: true;
  payload: {
    month: string;
    no_of_students: number;
  } [];
}
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private httpClient: HttpClient) {}

  getDashboardData(url: string): Observable<any> {
    return this.httpClient.get<any>(url, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  getEnrollmentTrend(url: string): Observable<IEnrollmentTrade> {
    return this.httpClient.get<IEnrollmentTrade>(url, {
      headers: { accept: '*/*' },
    }) as Observable<IEnrollmentTrade>;
  }
}
